import { Await, useLoaderData } from "react-router-dom";
import { Suspense } from "react";
import { OrderItemDetailsData } from "@/routes/order-items.$orderItem/route";
import { CompanyNote } from "@/entities/company-note";
import { StyledHtmlContent } from "@/components/styled-html-content";

export function CompanyNotes() {
  const { companyNote } = useLoaderData() as OrderItemDetailsData;

  return (
    <div className="space-y-4">
      <p className="text-xl font-medium text-gray-700">Company notes</p>

      <Suspense fallback={<p className="italic">Loading company notes...</p>}>
        <Await resolve={companyNote}>
          {(resolvedCompanyNote: CompanyNote) =>
            !resolvedCompanyNote.content.ops.length ? (
              <p className="italic text-sm text-slate-500">Company has no notes.</p>
            ) : (
              <StyledHtmlContent content={resolvedCompanyNote.htmlContent} />
            )
          }
        </Await>
      </Suspense>
    </div>
  );
}
